module.exports = __webpack_public_path__ + "img/dropdown.c9a4ac4b.svg";